module.exports = __webpack_public_path__ + "img/calendar.94c0fc59.svg";